export default function getCustomerType(isLoading: boolean, isNews: boolean): string {
  if (isLoading) return '';

  if (isNews) return 'News Corp customer';

  return 'Internal customer';
}
